module.exports = __webpack_public_path__ + "img/Blaise_pascal.0d074cb2.jpg";